var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 3H10c-3.86 0-7 3.14-7 7v12c0 3.86 3.14 7 7 7h12c3.86 0 7-3.14 7-7V10c0-3.86-3.14-7-7-7zm5 19c0 2.757-2.243 5-5 5H10c-2.757 0-5-2.243-5-5V10c0-2.757 2.243-5 5-5h12c2.757 0 5 2.243 5 5v12zM16 10c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6zm0 10c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4zm8-10.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 24 9.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.360b033cd26ac8bb04f3726f22eedef5.svg";
export { ForwardRef as ReactComponent };